import { SUPPORTED_LOCALES, type TAppLocale } from '@/locales'
import type { ITextObj } from '@team-milva/lab-models/textObj'

/** The build's bundled first-paint guess — see `brandStore.ts` for how the live
 * `PublicLabAccounts/{slug}` document then confirms, corrects, or overrides it. */
export interface IBundledBrand {
  slug: string | null
  displayName: ITextObj
  defaultLocale: TAppLocale
}

function isSupportedLocale(value: string | undefined): value is TAppLocale {
  return !!value && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

/** No brand configured — localhost, dev, and the future generic Milva build. */
export const NEUTRAL_BRAND: IBundledBrand = {
  slug: null,
  displayName: { en: 'Customer App', da: 'Customer App' },
  defaultLocale: 'en',
}

const slug = import.meta.env.VITE_BRAND_SLUG?.trim() || null
const rawName = import.meta.env.VITE_BRAND_DISPLAY_NAME?.trim()
const rawLocale = import.meta.env.VITE_BRAND_DEFAULT_LOCALE?.trim()
const defaultLocale = isSupportedLocale(rawLocale) ? rawLocale : NEUTRAL_BRAND.defaultLocale

/** This build's brand, resolved once from `VITE_BRAND_*` env vars — never the URL. */
export const BUNDLED_BRAND: IBundledBrand = slug
  ? { slug, displayName: { [defaultLocale]: rawName || slug }, defaultLocale }
  : NEUTRAL_BRAND
